import o from "axios";
const e = async (n, p, t) => {
  const a = `https://${n}.vtex.app/api/coupon/list`, s = Math.random(), { data: r } = t ? await o.post(a, { couponsList: t }) : await o.get(a, { params: { builder: p, random: s } });
  return r.coupons;
};
export {
  e as getCoupons
};
